module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHoAAAA0CAYAAABFCyz4AAABV0lEQVR4Xu2ULW4CQRxH/7v0FjShisOQVNBqbDXpESqq0EVX4EgQJK3DoRA9AYqAIBVVELIJU0G/IA1+9705wbz35jdZeEptoN55GRd5dNfPrfk5kKzUlF4+LjuvKSLtUuS99FE8rsbXm/+0GLrkj+UQ+nBSxCL26X45aA1PsQxdodC/wdOkyOPu73du6AqG/tr30Xee3fR37ZKzoq//Nps+nBOQ1y7eG1fNQXbb3/788WhjFYc3dMUDf+MZ2tAQAxBMF21oiAEIpos2NMQABNNFGxpiAILpog0NMQDBdNGGhhiAYLpoQ0MMQDBdtKEhBiCYLtrQEAMQTBdtaIgBCKaLNjTEAATTRRsaYgCC6aINDTEAwXTRhoYYgGC6aENDDEAwXbShIQYgmC7a0BADEEwXbWiIAQimizY0xAAE00UbGmIAgumiDQ0xAMF00ZjQT5sRhBWN+QnAGbs22oqBwAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/course/update-bg.png
// module id = UIFb
// module chunks = 96